import Optional from './optional';

export default function getValueFromLocation(location, key, or) {
  const orOption = Optional(or).or(null);
  return Optional(location.state)
    .map(state => state[key])
    .or(orOption);
}
